// extracted by mini-css-extract-plugin
export var currencyInput = "_l6-1";
export var currencySymbol = "_l6-0";